import React from "react";

const ShowPassword = props => {
    const onClick = (e) => {
        e.preventDefault();
        props.onClick();
    }

    return (
        <a className="show-password" tabIndex="-1" href="" onClick={onClick} />
    )
};

export default ShowPassword;